import React from 'react';
import './StatusCard.css';

interface StatusCardProps {
  title: string;
  value: string | number;
  icon: string;
  status?: 'pending' | 'completed' | 'active' | 'failed';
}

const StatusCard: React.FC<StatusCardProps> = ({
  title,
  value,
  icon,
  status = 'pending',
}) => {
  return (
    <div className={`status-card status-${status}`}>
      <div className="status-icon">{icon}</div>
      <div className="status-content">
        <div className="status-value">{value}</div>
        <div className="status-title">{title}</div>
      </div>
    </div>
  );
};

export default StatusCard;

